import Svg, { SvgEnum } from "../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../ui library/HNSColors";

export default function AvatarIcon({ isNotCopiedSelected }) {
  return (
    <div
      id="circle"
      className="flex h-[40px] w-[40px] items-center justify-center rounded-full p-4"
      style={{
        backgroundColor: isNotCopiedSelected ? HNSColors.secondary[800] : HNSColors.secondary[900],
      }}
    >
      <Svg name={SvgEnum.HisAI} color={HNSColors.secondary[500]} sx={{ width: 24, height: 24 }} />
    </div>
  );
}
